import type {ActionResponse, RawBodyMailSendRequest} from 'typings/portaro.be.types';
import {responseToData, transferify, unRestangularize} from 'shared/utils/data-service-utils';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type FinishedResponseInteractionService from './finished-response-interaction.service';

export default class MailerService {
    public static serviceName = 'mailerService';

    private readonly MAIL_ROUTE = 'mail';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService,
                private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    @ngAsync()
    public async sendMail(request: RawBodyMailSendRequest): Promise<void> {
        try {
            const actionResponse = await this.sendMailUsingRestangular(request);
            return this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            throw exceptionResponse;
        }
    }

    @unRestangularize()
    private async sendMailUsingRestangular(request: RawBodyMailSendRequest): Promise<ActionResponse> {
        try {
            request = Object.assign<RawBodyMailSendRequest, RawBodyMailSendRequest, RawBodyMailSendRequest>({} as RawBodyMailSendRequest, {attachments: []} as RawBodyMailSendRequest, request);
            return await this.Restangular
                .one(this.MAIL_ROUTE)
                .post(null, transferify(request));
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

}
